/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import { Dimensions, StyleSheet } from 'react-native';

const entireScreenWidth = Dimensions.get('window').width;
const entireScreenHeight = Dimensions.get('window').height;

export default StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
    },
      thumbnailImage: {
        width: 100,
        height: 100,
        resizeMode: 'contain',
        borderRadius: 44/2,
      },
    shadow: {
    shadowOffset: {
    width: 0,
    height: 0,
    },
    shadowOpacity: 50,
    shadowRadius: 10,
    shadowColor: "gray"
    },
    iconLink: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    },
    updateContainer: {
    alignSelf: 'center',
    width: "95%",
    height: "95%",
    backgroundColor: "white",
    borderRadius: 8,
    },
    updateDate: {
    paddingTop: 10,
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center"
    },
    updateTitle: {
    fontSize: 24,
    fontWeight: "bold",
    textAlign: "center",
    margin: 20,
    },
    textIcon: {
   marginTop: 20,
   marginBottom: 20,
   alignItems: 'center'
   },
   iconText: {
   fontSize: 10,
   marginLeft: 15,
   marginRight: 15
   },
attachmentContainer: {
flexGrow: 0,
height: 125
},
updateImage: {
height: entireScreenHeight / 4,
width: entireScreenWidth / 1.3,
alignSelf: 'center',
resizeMode: 'contain',
margin: 30
},
})